import React, {useEffect, useState} from 'react';
import {Button, Col, Container, Row} from 'react-bootstrap';
import {DocumentUtils} from "../../../../Utils/DocumentUtils";
import {Glyphicon} from "../../../Common/GlyphIcon";
import {service as SpeciesListService} from "../../../../Services/SpeciesListService";
import {usePermission} from "../../../../Hooks/PermissionHooks";
import {useMakePageRequest} from "../../../../Hooks/RequestHooks";
import {useCheckAuth} from "../../../../Hooks/RouteHooks";
import {useClassNames} from "../../../../Hooks/StyleHooks";

import {useContextIndependentPage} from "../../../../Hooks/ContextBuilderHooks";

import {StreamBankPageHeader} from "../../../Common/StreamBankPageHeader";
import {SpeciesListTable} from "./SpeciesListTable/SpeciesListTable";
import {SpeciesListTableFilter} from "./SpeciesListTable/SpeciesListTableFilter";

export const CustomListIndexPage = props => {
    useCheckAuth();
    useContextIndependentPage(props);

    const classNames = useClassNames('sb-species-lists-index-page');
    const makePageRequest = useMakePageRequest();
    const permission = usePermission();

    const [speciesLists, setSpeciesLists] = useState(null);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = () => {
        makePageRequest(
            () => SpeciesListService.GetSpeciesLists(),
            (x) => {
                setSpeciesLists(x.result);
            }
        );
    };

    const title = "Custom Plant Species Lists";

    return <Container className={classNames}>
        <StreamBankPageHeader
            Title={title}
        />
        <Row>
            <Col xs={12} md={6}><h2>{title}</h2></Col>
            <Col xs={12} md={6}>
                {
                    permission(['can_update_species_list']) ?
                        <Button variant="link" className="float-right h3" onClick={_ => DocumentUtils.changePage("/speciesLists/new")}>
                            <Glyphicon glyph="plus-sign" />Add List
                        </Button>:
                        null
                }
            </Col>
        </Row>
        <div>
            <hr className="special-hr"/>
        </div>
        <Row>
            <Col xs={12}>
                <SpeciesListTable
                    FilterComponent={SpeciesListTableFilter}
                    Data={speciesLists}
                />
            </Col>
        </Row>
    </Container>;
};


